/** M0 header chrome — 07-03 switcher suppression + 07-05 office masthead. */

export const STAFF_LABEL_STORAGE_KEY = 'beatq.merchant.staffLabel';

export function tradingLabel(status?: string | null): string {
  const value = (status ?? '').toUpperCase();
  if (value === 'ACTIVE' || value === 'OPEN') return 'Open';
  if (value === 'PAUSED' || value === 'SNOOZED' || value === 'BUSY') return 'Paused';
  if (value === 'DRAFT') return 'Draft';
  return status || 'Unknown';
}

export function shouldShowBusinessSelector(businessCount: number): boolean {
  return businessCount > 1;
}

export function shouldShowBranchSelector(branchCount: number): boolean {
  return branchCount > 1;
}

export function closedSelectorLabel(name: string): string {
  return name;
}

export function openedBranchOptionDetail(state: string, liveCount?: number | null): string {
  return liveCount != null ? `${state} · ${liveCount}` : state;
}

/** 07-05 masthead: trading state and live count once. Name the branch only when the selector is hidden (07-03). */
export function headerLiveStatus(input: {
  tradingState?: string | null;
  liveCount: number;
  branchName?: string | null;
}): string {
  const status = `${tradingLabel(input.tradingState)} · ${input.liveCount} live`;
  const name = input.branchName?.trim();
  return name ? `${name} · ${status}` : status;
}

/** Runtime connection chip — Production/Development + sockets vs poll. Never "demo" or "test". */
export function merchantRuntimeLabel(input: { production: boolean; socketsLive: boolean }): string {
  const environment = input.production ? 'Production' : 'Development';
  const transport = input.socketsLive ? 'Live sockets' : 'Polling';
  return `${environment} · ${transport}`;
}

export function isMerchantProductionBuild(): boolean {
  return import.meta.env.PROD === true;
}

export function staffLabelFromEmail(email: string): string {
  const local = email.split('@')[0]?.trim();
  return local || 'Account';
}

export function staffAccountLabel(stored?: string | null): string {
  const value = stored?.trim();
  return value || 'Account';
}

export function persistStaffLabel(label: string): void {
  if (typeof localStorage === 'undefined') return;
  const next = label.trim();
  if (!next) return;
  try {
    localStorage.setItem(STAFF_LABEL_STORAGE_KEY, next);
  } catch {
    /* private mode */
  }
}

export function readStaffLabel(): string {
  if (typeof localStorage === 'undefined') return 'Account';
  try {
    return staffAccountLabel(localStorage.getItem(STAFF_LABEL_STORAGE_KEY));
  } catch {
    return 'Account';
  }
}

export function clearStaffLabel(): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.removeItem(STAFF_LABEL_STORAGE_KEY);
  } catch {
    /* private mode */
  }
}
